import Vue from 'vue';

/**
 *
 * @returns {(string) => string}
 */
export default function useTranslations() {
  return Vue.t;
}
